import { Box, Paper, TableContainer } from '@mui/material'

import Pagination from '@/components/ui/pagination/Pagination'
import { Patient } from '@/core/models/patient.model'

import { PatientData } from '../model/usePatientsTableSelection'
import { InsPatientsCardView } from './InsPatientsCardView'
import { InsPatientsTable } from './InsPatientsTable'
import PatientsCardView from './PatientsCardView'
import PatientsTable from './PatientsTable'

type PaginationBoxProps = {
  rowsPerPageOptions: number[]
  page: number
  changePage: (page: number) => void
  changeItemsPerPage: (itemsPerPage: number) => void
  totalPatients: number
}

type PatientDirectoryResultsProps = {
  isInsMode: boolean
  isMobile: boolean
  insPatients: Patient[]
  legacyPatients: PatientData[]
  totalInsPatients: number
  totalLegacyPatients: number
  isFetchingInsPatients: boolean
  isFetchingLegacyPatients: boolean
  rowsPerPageOptions: number[]
  page: number
  changePage: (page: number) => void
  changeItemsPerPage: (itemsPerPage: number) => void
  onOpen: (patientId: string) => void
}

export function PatientDirectoryResults({
  isInsMode,
  isMobile,
  insPatients,
  legacyPatients,
  totalInsPatients,
  totalLegacyPatients,
  isFetchingInsPatients,
  isFetchingLegacyPatients,
  rowsPerPageOptions,
  page,
  changePage,
  changeItemsPerPage,
  onOpen,
}: PatientDirectoryResultsProps) {
  const totalPatients = isInsMode ? totalInsPatients : totalLegacyPatients
  const loading = isInsMode ? isFetchingInsPatients : isFetchingLegacyPatients

  if (isMobile) {
    return (
      <Box>
        <PaginationBox
          rowsPerPageOptions={rowsPerPageOptions}
          page={page}
          changePage={changePage}
          changeItemsPerPage={changeItemsPerPage}
          totalPatients={totalPatients}
        />
        {isInsMode ? (
          <InsPatientsCardView data={insPatients} loading={loading} onOpen={onOpen} />
        ) : (
          <PatientsCardView disableSelectRow data={legacyPatients} loading={loading} />
        )}
      </Box>
    )
  }

  return (
    <Paper>
      <TableContainer>
        {isInsMode ? (
          <InsPatientsTable data={insPatients} loading={loading} onOpen={onOpen} />
        ) : (
          <PatientsTable disableSelectRow data={legacyPatients} loading={loading} onOpen={(patient) => onOpen(patient._id)} showAddToPatientQueueButton />
        )}
      </TableContainer>
      <PaginationBox
        rowsPerPageOptions={rowsPerPageOptions}
        page={page}
        changePage={changePage}
        changeItemsPerPage={changeItemsPerPage}
        totalPatients={totalPatients}
      />
    </Paper>
  )
}

function PaginationBox({ rowsPerPageOptions, page, changePage, changeItemsPerPage, totalPatients }: PaginationBoxProps) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: '10px' }}>
      <Pagination
        color="primary"
        itemsPerPageOptions={rowsPerPageOptions}
        shape="rounded"
        page={page}
        onPageChange={changePage}
        onItemsPerPageChange={changeItemsPerPage}
        totalItems={totalPatients}
      />
    </Box>
  )
}
